module.exports = __webpack_public_path__ + "img/gintzin_maguey.fc29b3e7.jpg";